import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { abhaSendOtpType } from '@custom/Utils/constants/interfaces';
import sendAbhaOtpApi from '@custom/rtk-apis/abha/sendAbhaOtp';

const initialState = {
    data: {},
    status: "",
    loading: false,
    error: "",
    message: "",
};

const sendAbhaOtpSlice = createSlice({
    name: 'Send Abha OTP',
    initialState,
    reducers: {
      clearState: state => {
        state.data = {};
        state.status = '';
        state.loading = false;
        state.error = '';
        state.message = '';
      },
    },
    extraReducers: (builder) => {
      // Handle the different states of the async thunk (pending, fulfilled, rejected)
      builder
        .addCase(sendAbhaOtpApi.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(sendAbhaOtpApi.fulfilled, (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.status = action.payload.status;
          state.data = action.payload.data;
          state.message = action.payload.data.message;
        })
        .addCase(sendAbhaOtpApi.rejected, (state, action: PayloadAction<any>) => {
          console.log("state.error", action.payload)
          state.loading = false;
          state.status = "FAILED";
          state.error = action.payload;
        });
    },
  });
  
export default sendAbhaOtpSlice.reducer;
export const { clearState } = sendAbhaOtpSlice.actions;
